import { UserManagerWrapper } from "@/components/user-manager/user-manager-wrapper";

const UserManager = () => {
  return (
    <div className="h-full flex flex-col bg-background p-6 text-text-500">
      <div className="flex-1">
        <UserManagerWrapper />
      </div>
    </div>
  );
};

export default UserManager;
